import { isNotNullOrUndefined, stringNotEmpty } from 'Util/TypeGuards';
import { FreightContactEntity, FreightDetailEntity } from 'Models/Entities';
import { FormatPhone, upperCaseFirst } from 'Util/StringUtils';
import { getMessageByKey } from 'Stores/LanguageStore';
import {
	convertToCubicString,
	convertToWeightString,
	getCubicPerUnitFromFreightDetail,
} from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Shipment/CalculationHelpers';

export function getFreightBookingContactDetails(freightContact: FreightContactEntity) {
	const lineItems: [string, string][] = [];
	if (stringNotEmpty(freightContact.firstName) || stringNotEmpty(freightContact.lastName)) {
		lineItems.push([
			getMessageByKey('freight-booking-details__contact-details-name-field__label', 'Name'),
			`${upperCaseFirst(freightContact.firstName?.toLowerCase() ?? '')} ${upperCaseFirst(freightContact.lastName?.toLowerCase() ?? '')}`,
		]);
	}

	if (stringNotEmpty(freightContact.phone)) {
		lineItems.push([
			getMessageByKey('freight-booking-details__contact-details-phone-field__label', 'Phone'),
			FormatPhone(freightContact.phone),
		]);
	}

	if (stringNotEmpty(freightContact.email)) {
		lineItems.push([
			getMessageByKey('freight-booking-details__contact-details-email-field__label', 'Email'),
			freightContact.email,
		]);
	}

	if (stringNotEmpty(freightContact.companyName)) {
		lineItems.push([
			getMessageByKey('freight-booking-details__contact-details-company-name-field__label', 'Company name'),
			freightContact.companyName,
		]);
	}

	return lineItems;
}

export function getFreightBookingDetails(freightDetails: FreightDetailEntity, calculation?: string) {
	const lineItems: [string, string][] = [];
	lineItems.push([
		getMessageByKey('freight-booking-details__freight-details-quantity-field__label', 'Quantity'),
		freightDetails.quantity.toString(),
	]);
	lineItems.push([
		getMessageByKey('freight-booking-details__freight-details-weight-field__label', 'Weight (per unit)'),
		convertToWeightString(freightDetails.weight),
	]);
	lineItems.push([
		getMessageByKey('freight-booking-details__freight-details-cubic-field__label', 'Cubic (per unit)'),
		convertToCubicString(getCubicPerUnitFromFreightDetail(freightDetails)),
	]);
	lineItems.push([
		getMessageByKey('freight-booking-details__freight-details-total-weight-field__label', 'Total weight'),
		convertToWeightString((freightDetails?.weight ?? 0) * freightDetails.quantity),
	]);
	lineItems.push([
		getMessageByKey('freight-booking-details__freight-details-total-cubic-field__label-v2', 'Total cubic'),
		convertToCubicString(getCubicPerUnitFromFreightDetail(freightDetails) * freightDetails.quantity),
	]);
	lineItems.push([
		getMessageByKey('freight-booking-details__freight-details-calculation-field__label', 'Calculation'),
		calculation ?? '-',
	]);
	if (freightDetails.freightHandlings?.length > 0) {
		lineItems.push([
			getMessageByKey('freight-booking-details__freight-details-handling-field__label', 'Handling'),
			freightDetails.freightHandlings.map(x => x.freightHandling.label).join(', '),
		]);
	}
	lineItems.push([
		getMessageByKey('freight-booking-details__freight-details-description-field__label', 'Description'),
		freightDetails.description,
	]);

	return lineItems;
}
